import { render, staticRenderFns } from "./CbsAppFooter.vue?vue&type=template&id=4bf47692"
import script from "./CbsAppFooter.vue?vue&type=script&lang=js"
export * from "./CbsAppFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports